<template>
  <section id="servicos">
    <h2>Nossos Serviços</h2>
    <div class="cards">
      <Card
        v-for="(servico, index) in servicos"
        :key="index"
        :title="servico.title"
        link="#footer"
        subtitle="SAMATech"
      >
        <img :src="require('@/assets/img/servicos/' + servico.img)" alt="" />
      </Card>
    </div>
  </section>
</template>

<style scoped lang="scss">
.cards {
  padding: 0 2em;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  justify-content: space-evenly;
  margin: auto;
  @media screen and (max-width: 450px) {
    padding: 0 0.5em;
  }
}
h2 {
  text-align: center;
}
</style>

<script>
import Card from "@/components/cursos/CardCurso.vue";
export default {
  components: {
    Card
  },
  data() {
    return {
      servicos: [
        {
          title: "Apresentação ao Público<br> (Gráficos e Oratória)",
          img: "Apresentacao_ao_Publico.jpeg"
        },
        {
          title: "Biossegurança",
          img: "Biosseguranca.jpeg"
        },
        {
          title: "Formação de Equipes",
          img: "Formacao_de_Equipes.jpeg"
        },
        {
          title: "Gestão de Resíduos",
          img: "Gestao_de_Residuos.jpg"
        },
        {
          title: "Laboratório de Liderança",
          img: "Laboratorio_de_Lideranca.jpg"
        },
        {
          title: "Primeiros Socorros",
          img: "Primeiros_Socorros.jpg"
        },
        {
          title: "Processos Seletivos e Currículos",
          img: "Processos_Seletivos_e_Curriculos.jpeg"
        }
      ]
    };
  }
};
</script>